<app-header></app-header>
<div class="container">
  @if (pageLoading) {
    <mat-spinner></mat-spinner>
  }
  @if (notFound) {
    <p class="not-found">{{ 'quiz.not_found' | translate | async }}</p>
  }
  @if (game) {
  <mat-card>
    <mat-card-header>
      <mat-card-title><h1>{{ 'quiz.title' | translate | async }} <span>{{ game.title.text }}</span></h1></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="image-container">
        @if (game.coverImage && game.coverImage.url) {
          <picture>
            @if (game.coverImage.mediumPart) {
              <source [srcset]="game.coverImage.sourceUrl + game.coverImage.mediumPart + '/' + game.coverImage.rawUrl" type="image/{{game.coverImage.format}}" media="(max-width: 767px)">
            }
            <img [src]="game.coverImage.url" [alt]="game.coverImage.name" fetchpriority="high">
          </picture>
        }
        @if (!game.coverImage) {
          <img src="assets/common/dummy-cover.png" alt="Default Cover" class="placeholder" fetchpriority="high">
        }
      </div>
      <p>{{ game.description?.text }}
        @if (game.type === 'quiz') {
          {{ 'quiz.in_multiplayer' | translate | async }} {{ game.minTeamSize == 1 ? ('quiz.or_single_mode' | translate | async) : ''}}, {{ 'quiz.with' | translate | async }} {{ game.totalRounds }} {{ ['easy', 'medium'].includes(game.difficulty) ? ('quiz.exciting' | translate | async) : ('quiz.challenging' | translate | async) }} {{ 'quiz.questions' | translate | async }}
        }
      </p>
      <p class="question-types">
        @if (game.totalRounds > 0 && questionTypesText) {
          <span>{{ 'quiz.question_types' | translate | async }}:</span> {{ questionTypesText }}
        }
      </p>
      <div class="main-info">
        <div class="game-details">
          @if (game.totalRounds > 0) {
            <span class="item total-rounds">
              {{ 'game.details.total_questions' | translate | async }}:
              <span>{{ game.totalRounds }} {{ stagesText }}</span>
            </span>
          }
          <span class="item difficulty">
            {{ 'game.details.difficulty' | translate | async }}:
            <span [class]="game.difficulty">{{ game.difficulty }}</span>
          </span>
          <span class="item team-size">
            {{ 'game.details.players' | translate | async }}:
            <span>{{ game.minTeamSize }}-{{ game.maxTeamSize }}</span>
          </span>
          @if (game.creator) {
            <span class="item author">
              {{ 'game.details.author' | translate | async }}:
              <span>{{ game.creator.name }}</span>
            </span>
          }
          <span class="item published">
            {{ 'game.details.published' | translate | async }}:
            <span>{{ game.publishedAt | date: 'short' }}</span>
          </span>
          <span class="item available-on">
            {{ 'quiz.available_on' | translate | async }}:
            @for (lang of game.availableLangs; track lang) {
              <span>{{ lang }}<img [src]="'/assets/icons/lang/'+lang+'.svg'" alt="Flag" width="20" height="15"></span>
            }
          </span>
        </div>
        <div class="tags">
          @if (game && game.gTags) {
            <span>{{ 'quiz.tags' | translate | async }}:</span>
            @for (tag of game.gTags; track tag.name) {
              <a class="tag" [class]="tag.type" [routerLink]="[langPart+'/quizzes/tag/'+tag.name]">{{ tag.name }}</a>
            }
          }
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      @if (currentUser$ | async) {
        <a mat-flat-button color="secondary" [routerLink]="[langPart+'/playarea']">
          {{ 'quiz.actions.back_to_games' | translate | async }}
        </a>
        <button mat-flat-button color="primary" (click)="onStartGame(game.id)" [disabled]="gameLoading">
          {{ 'quiz.actions.start_game' | translate | async }}
        </button>
      }
      @else {
        <a mat-flat-button color="secondary" [routerLink]="[langPart+'/']">
          {{ 'quiz.actions.back_to_home' | translate | async }}
        </a>
        <a mat-flat-button color="primary" [routerLink]="[langPart+'/auth/login']">
          {{ 'quiz.actions.login_to_play' | translate | async }}
        </a>
      }
    </mat-card-actions>
  </mat-card>
}
</div>
<app-scroll-to-top></app-scroll-to-top>
<app-footer></app-footer>
